import React, { useState, useEffect, useContext } from "react";

import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import { useHistory } from "react-router-dom";

import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import DragAndDrop from "../../components/dragAndDrop/DragAndDrop";
import { createPointAccess } from "../../repositories/pointAccessRepository";
import { getFunctionalitiesPointAccess } from "../../repositories/functionalityPointAccessRepository";
import { getTypesPointAccess } from "../../repositories/typePointAccessRepository";
import { getLocalizationsPointAccess } from "../../repositories/localizationPointAccessRepository";
import { getProducts } from "../../repositories/productRepository";
import ModalImages from "./ModalImages";
import ModalButtons from "./ModalButtons";
import { createImage } from "../../repositories/imageRepository";
import { createImagePointAccess } from "../../repositories/imagePointAccessRepository";
import { createImageButtonPointAccess } from "../../repositories/imageButtonPointAccessRepository";
import {
  PointAccessContext,
  PointAccessContextProvider,
} from "../../context/PointAccessContext";

const View = () => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [optionFunctionalities, setOptionFunctionalities] = useState([]);
  const [optionTypes, setOptionTypes] = useState([]);
  const [optionLocalizations, setOptionLocalizations] = useState([]);
  const [optionProducts, setOptionProducts] = useState([]);
  const [functionality, setFunctionality] = useState(null);
  const [localization, setLocalization] = useState(null);
  const [product, setProduct] = useState(null);
  const [type, setType] = useState(null);
  const [active, setActive] = useState(true);
  const [loadingOptFunctionalities, setLoadingOptFunctionalities] =
    useState(false);
  const [loadingOptTypes, setLoadingOptTypes] = useState(false);
  const [loadingOptLocalizations, setLoadingOptLocalizations] = useState(false);
  const [loadingOptProducts, setLoadingOptProducts] = useState(false);
  const [errors, setErrors] = useState({});
  const {
    handleRemoveFile,
    handleAddFile,
    files,
    setFiles,
    setImagesSelectedsModal,
    setOpenModalImages,
    handleOpenModalButtons,
    loadingDragDrop,
  } = useContext(PointAccessContext);

  useEffect(() => {
    setFiles([]);
    setImagesSelectedsModal([]);
    sessionStorage.setItem("filespontoacesso", JSON.stringify({ values: [] }));
  }, [setFiles, setImagesSelectedsModal]);

  useEffect(() => {
    const getOptionsFunctionalities = async () => {
      try {
        setLoadingOptFunctionalities(true);
        const { data: result } = await getFunctionalitiesPointAccess();

        if (result.success) setOptionFunctionalities(result.data);

        setLoadingOptFunctionalities(false);
      } catch (error) {
        setLoadingOptFunctionalities(false);

        console.error("ERROR getFunctionalities CreatePointAccess", error);
      }
    };

    getOptionsFunctionalities();
  }, []);

  useEffect(() => {
    setLoadingOptTypes(true);
    const getOptionsTypes = async () => {
      try {
        const { data: result } = await getTypesPointAccess();

        if (result.success) setOptionTypes(result.data);

        setLoadingOptTypes(false);
      } catch (error) {
        setLoadingOptTypes(false);
        console.error("ERROR getTypes CreatePointAccess", error);
      }
    };

    getOptionsTypes();
  }, []);

  useEffect(() => {
    setLoadingOptLocalizations(true);
    const getOptionsLocalizations = async () => {
      try {
        const { data: result } = await getLocalizationsPointAccess();

        if (result.success) setOptionLocalizations(result.data);

        setLoadingOptLocalizations(false);
      } catch (error) {
        setLoadingOptLocalizations(false);
        console.error("ERROR getLocalizations CreatePointAccess", error);
      }
    };

    getOptionsLocalizations();
  }, []);

  useEffect(() => {
    setLoadingOptProducts(true);
    const getOptionsProducts = async () => {
      try {
        const { data: result } = await getProducts();

        if (result.success) setOptionProducts(result.data);

        setLoadingOptProducts(false);
      } catch (error) {
        setLoadingOptProducts(false);
        console.error("ERROR getProducts CreatePointAccess", error);
      }
    };

    getOptionsProducts();
  }, []);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      const resultValidation = validatesNotNull([
        { value: description, key: "description" },
        { value: startDate, key: "startDate" },
        { value: endDate, key: "endDate" },
        { value: functionality, key: "functionality" },
        { value: type, key: "type" },
        { value: localization, key: "localization" },
        { value: product, key: "product" },
      ]);

      if (
        startDate &&
        endDate &&
        Date.parse(startDate) >= Date.parse(endDate)
      ) {
        notify("A data fim deve ser maior que a data início.");
        resultValidation.error = true;
        resultValidation.errorsValidation.endDate = true;
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      }

      const { data: newPonitAccess } = await createPointAccess({
        body: {
          Descricao: description,
          DataInicio: startDate,
          DataFim: endDate,
          IdFuncionalidadePontoAcesso: functionality.Id,
          IdTipoPontoAcesso: type.Id,
          IdLocalizacaoPontoAcesso: localization.Id,
          IdProduto: product.Id,
          Ativo: active,
        },
      });

      if (!newPonitAccess.success) return setLoading(false);

      for (const element of files) {
        let idImage = element.Id;

        if (element.new) {
          const { data: newImage } = await createImage({
            body: {
              Caminho: element.file,
              Origem: "pontoacesso",
            },
          });

          idImage = newImage.data.Id;
        }

        createImagePointAccess({
          body: {
            IdImagem: idImage,
            IdPontoAcesso: newPonitAccess.data.Id,
          },
        });

        if (element.buttons) {
          for (const idButton of element.buttons) {
            createImageButtonPointAccess({
              body: {
                IdPontoAcesso: newPonitAccess.data.Id,
                IdImagem: idImage,
                IdBotaoPontoAcesso: idButton,
              },
            });
          }
        }
      }

      setLoading(false);
      notify("Registro criado com sucesso.", true, "info");
      goBack();
    } catch (error) {
      console.error("ERROR: CreatePointAccess", error);
      return setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <ModalImages />
      <ModalButtons />

      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="center"
          item
          lg={7}
          md={8}
          sm={10}
          xs={11}
          id="formContent"
        >
          <ArrowBackIcon className="iconGoBack" onClick={goBack} />

          <label className="title">Novo ponto de acesso</label>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={255}
              label="Descrição*"
              type="text"
              value={description}
              setValue={setDescription}
              error={errors.description}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldCustom
              label="Data Início*"
              type="date"
              value={startDate}
              setValue={setStartDate}
              error={errors.startDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldCustom
              label="Data Fim*"
              type="date"
              value={endDate}
              setValue={setEndDate}
              error={errors.endDate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <SelectCustom
              loading={loadingOptFunctionalities}
              label="Funcionalidade*"
              keyObject="Titulo"
              value={functionality}
              setValue={setFunctionality}
              error={errors.functionality}
              optionsList={optionFunctionalities}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <SelectCustom
              loading={loadingOptTypes}
              label="Tipo*"
              keyObject="Descricao"
              value={type}
              setValue={setType}
              error={errors.type}
              optionsList={optionTypes}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <SelectCustom
              loading={loadingOptLocalizations}
              label="Localização*"
              keyObject="Descricao"
              value={localization}
              setValue={setLocalization}
              error={errors.localization}
              optionsList={optionLocalizations}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <SelectCustom
              loading={loadingOptProducts}
              label="Produto*"
              keyObject="Descricao"
              value={product}
              setValue={setProduct}
              error={errors.product}
              optionsList={optionProducts}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={active}
                  onChange={() => setActive((e) => !e)}
                  name={active ? "Ativo" : "Inativo"}
                  color="primary"
                />
              }
              label={active ? "Ativo" : "Inativo"}
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <button
              type="button"
              className="btn btn-info btn-block"
              id="button-open-gallery"
              onClick={() => setOpenModalImages(true)}
            >
              Buscar imagens na galeria
            </button>
          </Grid>

          <Grid item xs={12} style={{ margin: "10px 0px 10px 0px" }}>
            <DragAndDrop
              loading={loadingDragDrop}
              handleFile={handleAddFile}
              typesAccept="image/png, image/jpeg, image/jpg"
            />
          </Grid>

          {files.map((img, index) => (
            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={6}
              key={index}
              container
              justify="center"
            >
              <Grid
                id="container-card"
                container
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12}>
                  <img
                    src={img.url}
                    alt="preview"
                    className="img-point-access"
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  id="group-icons"
                  container
                  justify="space-between"
                  spacing={1}
                >
                  <Grid item xs={12} container justify="center">
                    <label id="title">
                      Botões({img.buttons ? img.buttons.length : 0})
                    </label>
                  </Grid>
                  <Grid item xs={6} id="item-icon" container justify="flex-end">
                    <DeleteOutlineIcon
                      id="icon-remove"
                      onClick={() => handleRemoveFile(img, index)}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    id="item-icon"
                    container
                    justify="flex-start"
                  >
                    <AddCircleOutlineIcon
                      id="icon-play"
                      onClick={() => handleOpenModalButtons(index)}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}

          <Grid item container justify="center" xs={12}>
            <Grid item lg={6} xs={12}>
              <button
                id="buttonStyle"
                type="submit"
                className="btn btn-info btn-block"
              >
                Salvar
              </button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

const CreatePointAccess = (props) => (
  <PointAccessContextProvider>
    <View {...props} />
  </PointAccessContextProvider>
);

export { CreatePointAccess };
